import { render, staticRenderFns } from "./ItemsListOrdersItem.vue?vue&type=template&id=6c30cbb4&scoped=true"
import script from "./ItemsListOrdersItem.vue?vue&type=script&lang=js"
export * from "./ItemsListOrdersItem.vue?vue&type=script&lang=js"
import style0 from "./ItemsListOrdersItem.vue?vue&type=style&index=0&id=6c30cbb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c30cbb4",
  null
  
)

export default component.exports